import { z } from 'zod'

/**
 * A Zod schema that safely parses a JSON string into an unknown value.
 *
 * Unlike a raw `JSON.parse`, malformed input is captured as a Zod validation
 * error rather than an uncaught exception, so `safeParse` always returns a
 * result object instead of throwing.
 *
 * Pipe to a downstream schema to validate the parsed shape:
 * @example
 * const schema = parseJsonString.pipe(z.object({ count: z.number() }))
 * schema.safeParse('{"count":42}') // { success: true, data: { count: 42 } }
 * schema.safeParse('not json')     // { success: false, error: ... }
 */
export const parseJsonString = z.string().transform((s, ctx) => {
  try {
    return JSON.parse(s)
  } catch {
    ctx.addIssue({ code: 'custom', message: 'Invalid JSON' })
    return z.NEVER
  }
})
